import { TaskHeader } from 'app/agriculture/routes/Tasks/components/TaskHeader/TaskHeader';
import { TaskStats } from 'app/agriculture/routes/Tasks/components/TaskStats/TaskStats';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import './TimelineTaskPopoverContent.scss';

interface TimelineTaskPopoverContentProps {
    taskId: string;
}

export function TimelineTaskPopoverContent({ taskId }: TimelineTaskPopoverContentProps) {
    return (
        <SuspenseWrapper>
            <div className="TimelineTaskPopoverContent">
                <div className="TimelineTaskPopoverContent__section">
                    <TaskHeader taskId={taskId} enableTitleLink />
                </div>
                <div className="TimelineTaskPopoverContent__section">
                    <TaskStats taskId={taskId} />
                </div>
            </div>
        </SuspenseWrapper>
    );
}
